import { render } from "./DataPager.vue?vue&type=template&id=3d8a5bfd"
import script from "./DataPager.vue?vue&type=script&lang=js"
export * from "./DataPager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable/DataPager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d8a5bfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d8a5bfd', __exports__)) {
    console.log('reload')
    api.reload('3d8a5bfd', __exports__)
  }
  
  module.hot.accept("./DataPager.vue?vue&type=template&id=3d8a5bfd", () => {
    console.log('re-render')
    api.rerender('3d8a5bfd', render)
  })

}


export default __exports__